import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "opisko.teacherProfile.v1";
const HINT_KEY = "opisko.profileHintDismissed.v1";

export const EMPTY_PROFILE = {
  signature_name: "",
  tone: "neutralan", // 'topao' | 'neutralan' | 'formalan'
  length: "srednji", // 'kratak' | 'srednji' | 'dugi'
  custom_notes: "",
  custom_tags: {}, // { [subjectSlug]: string[] } – vrijedi za sve razrede
};

export const TONE_LABELS = {
  topao: "Topao i osobniji",
  neutralan: "Neutralan i profesionalan",
  formalan: "Formalan i sažet",
};

export const LENGTH_LABELS = {
  kratak: "Kratak (2–3 rečenice)",
  srednji: "Srednji (4–6 rečenica)",
  dugi: "Detaljan (6–8 rečenica)",
};

function readProfile() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return EMPTY_PROFILE;
    const parsed = JSON.parse(raw);
    return { ...EMPTY_PROFILE, ...parsed };
  } catch {
    return EMPTY_PROFILE;
  }
}

export function isProfileSet(p) {
  if (!p) return false;
  return Boolean(
    (p.signature_name && p.signature_name.trim()) ||
      (p.custom_notes && p.custom_notes.trim()) ||
      (p.tone && p.tone !== "neutralan") ||
      (p.length && p.length !== "srednji")
  );
}

export default function useTeacherProfile() {
  const [profile, setProfile] = useState(EMPTY_PROFILE);
  const [hintDismissed, setHintDismissed] = useState(true);

  useEffect(() => {
    setProfile(readProfile());
    try {
      setHintDismissed(localStorage.getItem(HINT_KEY) === "1");
    } catch {
      setHintDismissed(false);
    }
  }, []);

  const save = useCallback((next) => {
    const merged = { ...EMPTY_PROFILE, ...next };
    setProfile(merged);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    } catch {
      /* ignore */
    }
  }, []);

  // Clears tone/notes but keeps the teacher's custom tags.
  const reset = useCallback(() => {
    setProfile((prev) => {
      const next = { ...EMPTY_PROFILE, custom_tags: prev.custom_tags || {} };
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const dismissHint = useCallback(() => {
    setHintDismissed(true);
    try {
      localStorage.setItem(HINT_KEY, "1");
    } catch {
      /* ignore */
    }
  }, []);

  return { profile, save, reset, hintDismissed, dismissHint };
}
